export default __webpack_public_path__ + "d5bbdafc518495750ab8544f9d011f9e.glb";